import { Controller } from "@hotwired/stimulus"
import { debug } from "../debug"

// Connects to data-controller="back-to-top"
export default class extends Controller {
  static targets = ["button"]
  
  connect() {
    debug("Back to top controller connected")
    this.scrollThreshold = 300
    
    // On mobile, we need to handle the button differently
    if (window.innerWidth <= 768) {
      this.setupMobileButton()
    } else {
      this.addScrollListener()
    }
  }
  
  disconnect() {
    // Clean up event listeners when controller disconnects
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler)
    }
    if (this.mobileScrollHandler) {
      window.removeEventListener('scroll', this.mobileScrollHandler)
    }
    if (this.mobileButton) {
      this.mobileButton.remove()
    }
  }
  
  addScrollListener() {
    // Use arrow function to preserve 'this' context
    this.scrollHandler = () => this.toggleVisibility()
    
    // Add scroll listener with passive option for better performance
    window.addEventListener('scroll', this.scrollHandler, { passive: true })
    
    // Initial check in case page is already scrolled
    this.toggleVisibility()
  }
  
  toggleVisibility() {
    if (window.scrollY > this.scrollThreshold) {
      this.buttonTarget.classList.add('visible')
    } else {
      this.buttonTarget.classList.remove('visible')
    }
  }
  
  scrollToTop(event) {
    event.preventDefault()
    debug('Back to top button clicked')
    
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  
  setupMobileButton() {
    debug('Setting up mobile back to top button')
    
    // Move button to body to escape parent stacking contexts
    const button = this.buttonTarget
    const newButton = button.cloneNode(true)
    
    // Remove original button from DOM
    button.remove()
    
    // Add the cloned button to body
    document.body.appendChild(newButton)
    
    // Force ultra-high z-index and positioning
    newButton.style.zIndex = '9999999'
    newButton.style.position = 'fixed'
    newButton.style.isolation = 'isolate'
    newButton.style.bottom = '20px'
    newButton.style.right = '20px'
    
    // Manually handle scroll events for the mobile button
    const scrollHandler = () => {
      if (window.scrollY > this.scrollThreshold) {
        newButton.classList.add('visible')
      } else {
        newButton.classList.remove('visible')
      }
    }
    
    // Add scroll listener
    window.addEventListener('scroll', scrollHandler, { passive: true })
    
    // Add click handler
    newButton.addEventListener('click', (e) => {
      e.preventDefault()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    })
    
    // Initial check
    scrollHandler()
    
    // Store for cleanup
    this.mobileButton = newButton
    this.mobileScrollHandler = scrollHandler
    
    debug('Mobile back to top button setup complete')
  }
}
